<div class="caption-bar">
  <div class="caption">Mitarbeiterübersicht</div>
  <ion-button (click)="createNewUser()">
    <ion-icon size="large" name="add"></ion-icon>
  </ion-button>
</div>
<lib-user-overview></lib-user-overview>
